import { fetchPost, fetchPut, fetchGet, fetchDelete } from '@/utils/request'

export function housesAutoComplete (query) {
    return fetchGet('/gateway/v1/houses-auto-complete', query)
}
/* 获取搜索楼盘列表 */
export function getHouseSearchBaseList (params) {
    return fetchGet('/gateway/v1/houses-auto-complete', params)
}